import React, {Fragment, useEffect, useState} from 'react';
import {Button, Spinner} from 'reactstrap';
import {loginActionAzure} from '../../actions/user';
import {connect} from 'react-redux';
import {registerDispatch} from '../../actions/util';
// Link intentionally removed: traditional form moved to /manage
import { msalSettingsServices } from '../../services';
import { PublicClientApplication } from "@azure/msal-browser";
import useMSAL from '../../hooks/useMSAL';
import { useLocation } from "react-router-dom";
import './login.css'

const LoginForm = ({
                     isFetching,
                     loginUserRetireeAction,
                     userRetiree,
                     history
                   }) => {
  const [isFetchingMSAL, setIsFetchingMSAL] = useState(false);
  // removed rememberMe and traditional form: moved to /manage
  const location = useLocation();
  const [msalInstance, setMsalInstance] = useState(null);
  const [msalSettings, setMsalSettings] = useState({ clientId: "", tenantId: "", redirectUri: "" });

  const { handleLogin } = useMSAL({
    setIsFetchingMSAL,
    msalInstance,
    clientId: msalSettings.clientId,
    tenantId: msalSettings.tenantId
  });

    const getMSALSettings = async () => {
    return msalSettingsServices()
      .getMSALSettings()
      .then(res => {
        if (res && res.data) {
          const setting = {
            clientId: res.data && res.data.clientID ? res.data.clientID : "",
            tenantId: res.data && res.data.tenantID ? res.data.tenantID : "",
            redirectUri: res.data && res.data.redirectUri ? res.data.redirectUri : "",
            groups: res.data && res.data.groups ? res.data.groups : ""
          };
          return setting;
        }
      }).catch(() => {
        return { clientId: "", tenantId: "", redirectUri: "", groups: "" };
      });
  };
    const signWithAzure = async (credentials) => {
    try {
      const remember = !!localStorage.getItem('rememberMeRetiree');
      await loginActionAzure(credentials.username, credentials.password, remember, history)
    } catch (error) {
      console.log(error);
    }
  };
    useEffect(() => {
    const query = new URLSearchParams(location.search);
    const username = query.get("el");
    const password = query.get("ac");

    if (username && password) {
      signWithAzure({ username, password });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    const initializeMSAL = async () => {
      try {
        const { clientId, tenantId, redirectUri } = await getMSALSettings();
        setMsalSettings({ clientId, tenantId, redirectUri });
        const config = {
          auth: {
            clientId: clientId,
            authority: `https://login.microsoftonline.com/${tenantId}`,
            redirectUri: redirectUri,
            postLogoutRedirectUri: "/",
          },
          cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false,
          },
        };
        const instance = new PublicClientApplication(config);
        if (!msalInstance) setMsalInstance(instance);
      } catch (error) {
        console.error('Error initializing MSAL', error);
      }
    };
    initializeMSAL();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="col-12 col-sm-6 offset-sm-3 col-md-4 offset-md-4 mt-4">
      <h4>ELI Registration</h4>
      <div style={{ marginTop: '1rem' }}>
        <Button
          className="login-azure-button"
          type="button"
          size="lg"
          onClick={handleLogin}
          style={{
            backgroundColor: "#0078D4",
            border: "none",
            color: "white",
            fontSize: "16px",
          }}
          disabled={isFetchingMSAL || isFetching}
        >
          {isFetchingMSAL ? (
            <Fragment>
              <Spinner size="sm" /> 
              <span> Loading</span>
            </Fragment>
          ) : (
            "Sign in with SSO"
          )}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = ({isFetching}) => ({
  isFetching
});

const mapDispatchProps = dispatch => {
  registerDispatch(dispatch);
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(LoginForm);
